const theme = {
  fontFamily: "Roboto, Arial, sans-serif",
  colors: {},
  skeleton: {
    backgroundColor: "transparent",
    filter: "brightness(140%)",
  },
  slider: {
    padding: 0,
  },
  sliderSmall: {
    padding: 0,
  },
  sliderMobile: {
    padding: 0,
  },
  sliderTitle: {
    color: "#051b35",
    fontSize: "18px",
    fontWeight: 400,
  },
  image: {
    aspectRatio: "4 / 3",
    borderRadius: "6px",
  },
  sliderItemLabel: {
    color: "#051b35",
    fontWeight: 400,
  },
  moreBtn: {
    display: "none",
  },
  sliderHeader: {
    margin: "20px 0",
  },
  sliderHeaderSmall: {
    margin: "20px 0",
  },
  sliderHeaderMobile: {
    margin: " 16px 0",
  },
  playBtnHighlights: {
    color: "rgb(64,115,149)",
  },
  slideBtn: {
    backgroundColor: "none",
    color: "#aaa",
  },
};

export default theme;
